
import PrivacyPolicy from "../components/Sections/PrivacyPolicy";

export default function PrivacyPolicyPage() {
//   return < AboutBanner/>
  return (
    <>
        
        <PrivacyPolicy />

    </>
  );
}
